import React from 'react';
import { UsersIcon } from 'lucide-react';
const TOTAL_SPOTS = 200;
const SPOTS_LEFT = 17;

/** Scarcity trigger: a nearly-full progress bar showing remaining promotional spots. */
export function ScarcityBar({
  tone = 'dark'
}: {
  tone?: 'dark' | 'light';
}) {
  const claimed = TOTAL_SPOTS - SPOTS_LEFT;
  const percent = Math.round(claimed / TOTAL_SPOTS * 100);
  const isDark = tone === 'dark';
  return <div className="w-full" data-id="element-274" data-mp="2b6gx7jwb75td">
      <div className="mb-2 flex items-baseline justify-between gap-3" data-id="element-275" data-mp="2b56yqtljnvm7">
        <p className={`flex items-center gap-1.5 text-[11.5px] font-bold uppercase tracking-[0.1em] ${isDark ? 'text-gold-light' : 'text-navy/70'}`} data-id="element-276" data-mp="2g638vowhoe02">
          <UsersIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-277" data-mp="274da1y0a2cs9" />
          Only {SPOTS_LEFT} spots left at $27
        </p>
        <p className={`text-[11.5px] font-bold tabular-nums ${isDark ? 'text-cream/70' : 'text-navy/60'}`} data-id="element-278" data-mp="g0adu6wuoke">
          {percent}% claimed
        </p>
      </div>
      <div className={`h-3 w-full overflow-hidden rounded-full ${isDark ? 'bg-white/12' : 'bg-navy/10'}`} role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-279" data-mp="33mmrck767rqu">
        <div className="h-full rounded-full bg-gold-light" style={{
        width: `${percent}%`
      }} data-id="element-280" data-mp="38dlbxvz6zbzw" />
      </div>
      <p className={`mt-2 text-[12px] leading-relaxed ${isDark ? 'text-cream/60' : 'text-navy/55'}`} data-id="element-281" data-mp="2kn8y64h9ml1e">
        {claimed} of {TOTAL_SPOTS} promotional spots have been taken. When they run out, the price returns to $97.
      </p>
    </div>;
}